import { useRouter } from "next/router";
import React, { useRef, useEffect } from "react";
import { Anchor, Container } from "./styles";
import gsap from "@/lib/gsap";

export type ParagraphIndexProps = {
  paragraphIndex: any[];
  activeSectionId?: string;
};

const ParagraphIndex: React.FC<ParagraphIndexProps> = ({
  paragraphIndex,
  activeSectionId,
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const router = useRouter();
  useEffect(() => {
    // 👇️ only runs once
    const initialTarget = router.asPath.split("#")[1]
      ? decodeURIComponent(router.asPath.split("#")[1])
      : paragraphIndex
      ? paragraphIndex[0].slug
      : null;

    if (typeof window !== "undefined" && initialTarget) {
      setTimeout(() => {
        gsap.to(window, { scrollTo: `#${initialTarget}` });
      }, 1000);
    }
  }, []); // 👈️ empty dependencies array

  return (
    <Container ref={containerRef}>
      {paragraphIndex?.map((heading, index) => {
        const target = "#" + heading.slug;
        return (
          <Anchor
            href={target}
            key={target}
            aria-current={activeSectionId === heading.slug ? "true" : "false"}
            onClick={async (e) => {
              e.preventDefault();
              await gsap.to(window, { scrollTo: target });
              window.location.hash = heading.slug;
            }}
          >
            {heading?.heading}
          </Anchor>
        );
      })}
    </Container>
  );
};

export default ParagraphIndex;
